export enum EventName {
  DataLoad = 'dataload',
}
